






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";
import Locale from "@/service/Locale/Locale";

import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
import {
  required,
  confirmed,
  numeric,
  email,
  max,
} from "vee-validate/dist/rules";

const quantityRule = {
  validate(value: string): boolean {
    return !!value.match(/^[0-9０-９,.\x20\u3000]*$/g); // 半角全角数字スペース、',', '.',
  },
};
const furiganaRule = {
  validate(value: string): boolean {
    return !!value.match(/^[ｦ-ﾟｰァ-ヾ\s]+$/u);
  },
};

extend("required", required);
extend("confirmed", confirmed);
extend("numeric", numeric);
extend("email", email);
extend("quantity_rule", quantityRule);
extend("furigana_rule", furiganaRule);
extend("max", max);

interface InquiryValidationProps {
  actionUrl: string;
  csrfToken: string;
  lang: any;
  maxErrorText: string;
  dev: any;
  furiganaErrorText: string;
  emailErrorText: string;
  locale: string;
  countries: any;
  category: string;
  corp: string;
  corpFurigana: string;
  dept: string;
  nameOfPic: string;
  nameOfPicFurigana: string;
  mailAddressOfPic: string;
  nameOfAdmin: string;
  mailAddressOfAdmin: string;
  url: string;
  devices: string[];
  environments: string[];
  grade: string;
  quantity: number | string;
  desiredLicenseAvailableDate: string;
  paymentMethod: string;
  postalCode: string;
  countryCode: string;
  addressFirst: string;
  addressSecond: string;
  addressThird: string;
  addressFourth: string;
  phoneNumberCountryCode: string;
  phoneNumber: string;
  content: string;
}

interface InquiryValidationData {
  categoryData: string;
  corpData: string;
  corpFuriganaData: string;
  deptData: string;
  nameOfPicData: string;
  nameOfPicFuriganaData: string;
  nameOfAdminData: string;
  mailAddressOfAdminData: string;
  urlData: string;
  devicesData: string[];
  environmentsData: string[];
  gradeData: string;
  displayQuantityData: string;
  desiredLicenseAvailableDateData: string;
  paymentMethodData: string;
  postalCodeData: string;
  countryCodeData: string;
  address1Data: string;
  address2Data: string;
  address3Data: string;
  address4Data: string;
  phoneNumberCountryCodeData: string;
  phoneNumberData: string;
  mailAddressOfPicData: string;
  contentData: string;
  agreeData: string[];
  inputRule: string;
  notRequiredInputRule: string;
  requiredRule: string;
  radioRule: string;
  checkboxRule: string;
  mailAddressOfPicRule: string;
  mailAddressOfAdminRule: string;
  quantityRule: string;
  furiganaRule: string;
  contentRule: string;
  corpMaxLength: number;
  corpFuriganaMaxLength: number;
  deptMaxLength: number;
  nameOfPicMaxLength: number;
  nameOfPicFuriganaMaxLength: number;
  mailAddressOfPicMaxLength: number;
  desiredLicenseAvailableDateMaxLength: number;
  nameOfAdminMaxLength: number;
  mailAddressOfAdminMaxLength: number;
  urlMaxLength: number;
  postalCodeMaxLength: number;
  address1MaxLength: number;
  address2MaxLength: number;
  address3MaxLength: number;
  address4MaxLength: number;
  phoneNumberMaxLength: number;
  contentMaxLength: number;
  showMailAddressOfPicError: boolean;
  showMailAddressOfAdminError: boolean;
}

type Methods = {
  onSubmit: () => void;
  getCountryCode: () => string;
};

// FIXME 引数のanyを修正する
export default Vue.extend<any, Methods, any, any>({
  name: "vc-inquiry-validation",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    actionUrl: {
      type: String as PropType<InquiryValidationProps["actionUrl"]>,
      default: "",
    },
    csrfToken: {
      type: String as PropType<InquiryValidationProps["csrfToken"]>,
      default: "",
    },
    lang: {
      type: Object as PropType<InquiryValidationProps["lang"]>,
      default: () => {},
    },
    maxErrorText: {
      type: String as PropType<InquiryValidationProps["maxErrorText"]>,
      default: "",
    },
    dev: {
      type: Object as PropType<InquiryValidationProps["dev"]>,
      default: () => {},
    },
    furiganaErrorText: {
      type: String as PropType<InquiryValidationProps["furiganaErrorText"]>,
      default: "",
    },
    emailErrorText: {
      type: String as PropType<InquiryValidationProps["emailErrorText"]>,
      default: "",
    },
    locale: {
      type: String as PropType<InquiryValidationProps["locale"]>,
      default: "",
    },
    countries: {
      type: Array as PropType<InquiryValidationProps["countries"]>,
      default: () => [],
    },
    category: {
      type: String as PropType<InquiryValidationProps["category"]>,
      default: "",
    },
    corp: {
      type: String as PropType<InquiryValidationProps["corp"]>,
      default: "",
    },
    corpFurigana: {
      type: String as PropType<InquiryValidationProps["corpFurigana"]>,
      default: "",
    },
    dept: {
      type: String as PropType<InquiryValidationProps["dept"]>,
      default: "",
    },
    nameOfPic: {
      type: String as PropType<InquiryValidationProps["nameOfPic"]>,
      default: "",
    },
    nameOfPicFurigana: {
      type: String as PropType<InquiryValidationProps["nameOfPicFurigana"]>,
      default: "",
    },
    nameOfAdmin: {
      type: String as PropType<InquiryValidationProps["nameOfAdmin"]>,
      default: "",
    },
    mailAddressOfAdmin: {
      type: String as PropType<InquiryValidationProps["mailAddressOfAdmin"]>,
      default: "",
    },
    url: {
      type: String as PropType<InquiryValidationProps["url"]>,
      default: "",
    },
    devices: {
      type: Array as PropType<InquiryValidationProps["devices"]>,
      default: () => [],
    },
    environments: {
      type: Array as PropType<InquiryValidationProps["environments"]>,
      default: () => [],
    },
    grade: {
      type: String as PropType<InquiryValidationProps["grade"]>,
      default: "",
    },
    quantity: {
      type: [Number, String] as PropType<InquiryValidationProps["quantity"]>,
      default: 0,
    },
    desiredLicenseAvailableDate: {
      type: String as PropType<
        InquiryValidationProps["desiredLicenseAvailableDate"]
      >,
      default: "",
    },
    paymentMethod: {
      type: String as PropType<InquiryValidationProps["paymentMethod"]>,
      default: "",
    },
    countryCode: {
      type: String as PropType<InquiryValidationProps["countryCode"]>,
      default: "",
    },
    postalCode: {
      type: String as PropType<InquiryValidationProps["postalCode"]>,
      default: "",
    },
    addressFirst: {
      type: String as PropType<InquiryValidationProps["addressFirst"]>,
      default: "",
    },
    addressSecond: {
      type: String as PropType<InquiryValidationProps["addressSecond"]>,
      default: "",
    },
    addressThird: {
      type: String as PropType<InquiryValidationProps["addressThird"]>,
      default: "",
    },
    addressFourth: {
      type: String as PropType<InquiryValidationProps["addressFourth"]>,
      default: "",
    },
    phoneNumberCountryCode: {
      type: String as PropType<
        InquiryValidationProps["phoneNumberCountryCode"]
      >,
      default: "",
    },
    phoneNumber: {
      type: String as PropType<InquiryValidationProps["phoneNumber"]>,
      default: "",
    },
    content: {
      type: String as PropType<InquiryValidationProps["content"]>,
      default: "",
    },
    mailAddressOfPic: {
      type: String as PropType<InquiryValidationProps["mailAddressOfPic"]>,
      default: "",
    },
  },
  data(): InquiryValidationData {
    return {
      categoryData: this.category,
      corpData: this.corp,
      corpFuriganaData: this.corpFurigana,
      deptData: this.dept,
      nameOfPicData: this.nameOfPic,
      nameOfPicFuriganaData: this.nameOfPicFurigana,
      nameOfAdminData: this.nameOfAdmin,
      mailAddressOfAdminData: this.mailAddressOfAdmin,
      urlData: this.url,
      devicesData: this.devices || [],
      environmentsData: this.environments || [],
      gradeData: this.grade,
      displayQuantityData: String(this.quantity),
      desiredLicenseAvailableDateData: this.desiredLicenseAvailableDate,
      paymentMethodData: this.paymentMethod,
      postalCodeData: this.postalCode,
      countryCodeData: this.countryCode,
      address1Data: this.addressFirst,
      address2Data: this.addressSecond,
      address3Data: this.addressThird,
      address4Data: this.addressFourth,
      phoneNumberCountryCodeData: this.phoneNumberCountryCode,
      phoneNumberData: this.phoneNumber,
      mailAddressOfPicData: this.mailAddressOfPic,
      contentData: this.content,
      agreeData: [],
      inputRule: "required|max:",
      requiredRule: "required:true",
      notRequiredInputRule: "max:",
      radioRule: "required:true",
      checkboxRule: "required:true",
      mailAddressOfPicRule: "required|email|max:",
      mailAddressOfAdminRule: "required|email|max:",
      quantityRule: "required|quantity_rule",
      furiganaRule: "required|furigana_rule|max:",
      contentRule: "max:",
      corpMaxLength: 190,
      corpFuriganaMaxLength: 190,
      deptMaxLength: 190,
      nameOfPicMaxLength: 190,
      nameOfPicFuriganaMaxLength: 190,
      mailAddressOfPicMaxLength: 190,
      nameOfAdminMaxLength: 190,
      mailAddressOfAdminMaxLength: 190,
      urlMaxLength: 255,
      desiredLicenseAvailableDateMaxLength: 190,
      postalCodeMaxLength: 190,
      address1MaxLength: 190,
      address2MaxLength: 190,
      address3MaxLength: 190,
      address4MaxLength: 190,
      phoneNumberMaxLength: 190,
      contentMaxLength: 10000,
      showMailAddressOfPicError: true,
      showMailAddressOfAdminError: true,
    };
  },
  mounted() {
    this.countryCodeData = this.countryCode || this.getCountryCode();
    this.phoneNumberCountryCodeData =
      this.phoneNumberCountryCode || this.getCountryCode();

    const locale = Locale.getLocale();
    const requiredMessage = this.lang.error_form_required;
    const furiganaMessage = this.furiganaErrorText; // 日本語ロケールのみ表示

    localize(locale, {
      messages: {},
      fields: {
        categoryProvider: {
          required: requiredMessage,
        },
        corpProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.corpMaxLength),
        },
        corpFuriganaProvider: {
          required: requiredMessage,
          furigana_rule: furiganaMessage,
          max: this.maxErrorText.replace(":length", this.corpFuriganaMaxLength),
        },
        deptProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.deptMaxLength),
        },
        nameOfPicProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.nameOfPicMaxLength),
        },
        nameOfPicFuriganaProvider: {
          required: requiredMessage,
          furigana_rule: furiganaMessage,
          max: this.maxErrorText.replace(
            ":length",
            this.nameOfPicFuriganaMaxLength
          ),
        },
        nameOfAdminProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.nameOfAdminMaxLength),
        },
        mailAddressOfAdminProvider: {
          required: requiredMessage,
          email: this.emailErrorText,
          max: this.maxErrorText.replace(
            ":length",
            this.mailAddressOfAdminMaxLength
          ),
        },
        urlProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.urlMaxLength),
        },
        devicesProvider: {
          required: requiredMessage,
        },
        environmentProvider: {
          required: requiredMessage,
        },
        gradeProvider: {
          required: requiredMessage,
        },
        quantityProvider: {
          required: requiredMessage,
          quantity_rule: this.lang.error_licence_format_invalid,
        },
        desiredLicenseAvailableDateProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(
            ":length",
            this.desiredLicenseAvailableDateMaxLength
          ),
        },
        paymentMethodProvider: {
          required: requiredMessage,
        },
        postalCodeProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.postalCodeMaxLength),
        },
        address1Provider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.address1MaxLength),
        },
        address2Provider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.address2MaxLength),
        },
        address3Provider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.address3MaxLength),
        },
        address4Provider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.address4MaxLength),
        },
        phoneNumberProvider: {
          required: requiredMessage,
          max: this.maxErrorText.replace(":length", this.phoneNumberMaxLength),
        },
        mailAddressOfPicProvider: {
          required: requiredMessage,
          email: this.emailErrorText,
          max: this.maxErrorText.replace(
            ":length",
            this.mailAddressOfPicMaxLength
          ),
        },
        contentProvider: {
          max: this.maxErrorText.replace(":length", this.contentMaxLength),
        },
        agreeProvider: {},
      },
    });
  },
  computed: {
    firstCountryList() {
      return this.countries.filter((country: any) => {
        return country.display_list_priority === 1;
      });
    },
    secondCountryList() {
      return this.countries.filter((country: any) => {
        return country.display_list_priority === 2;
      });
    },
    parsedQuantityData() {
      return parseInt(
        this.displayQuantityData
          .replace(/[,.\x20\u3000]/g, "")
          .replace(/[０-９]/g, (num: string) =>
            String.fromCharCode(num.charCodeAt(0) - 0xfee0)
          )
      );
    },
  },
  methods: {
    onSubmit(): void {
      (this.$refs.form as HTMLFormElement).submit();
    },
    getCountryCode(): string {
      const locale = Locale.getLocale();
      if (locale === "ja-jp") {
        return "JPN";
      } else if (locale === "ko-kr") {
        return "KOR";
      } else if (locale === "zh-tw") {
        return "TWN";
      } else if (locale === "fr-fr") {
        return "FRA";
      } else if (locale === "de-de") {
        return "DEU";
      } else if (locale === "es-es") {
        return "ESP";
      } else {
        return "USA";
      }
    },
  },
});
